import {
    REQUEST_GET_LIST_DOCUMENTS,
    SUCCESS_GET_LIST_DOCUMENTS,
    FAILURE_GET_LIST_DOCUMENTS,
    REQUEST_UPDATE_DOCUMENT,
    SUCCESS_UPDATE_DOCUMENT,
    FAILURE_UPDATE_DOCUMENT,
    REQUEST_UPDATE_EDIT_HISTORY_DOCUMENT,
    SUCCESS_UPDATE_EDIT_HISTORY_DOCUMENT,
    FAILURE_UPDATE_EDIT_HISTORY_DOCUMENT,
    REQUEST_FILE_DOWNLOAD,
    SUCCESS_FILE_DOWNLOAD,
    FAILURE_FILE_DOWNLOAD,
    REQUEST_GET_DOCUMENT_EDIT_HISTORY,
    SUCCESS_GET_DOCUMENT_EDIT_HISTORY,
    FAILURE_GET_DOCUMENT_EDIT_HISTORY,
    REQUEST_GET_SEARCH_RESULT,
    SUCCESS_GET_SEARCH_RESULT,
    FAILURE_GET_SEARCH_RESULT,

    // UPDATE_SESSION_EXPIRY,
} from "../Constant/listDocuments";


export const requestGetListDocuments = () => ({
    type: REQUEST_GET_LIST_DOCUMENTS,
})
export const getListDocumentsSuccess = (data) => ({
    type: SUCCESS_GET_LIST_DOCUMENTS,
    payload: data,
})
export const getListDocumentsFailure = (error) => ({
    type: FAILURE_GET_LIST_DOCUMENTS,
    payload: error,
})

export const requestUpdateDocument = () => ({
    type: REQUEST_UPDATE_DOCUMENT,
})
export const updateDocumentSuccess = (data) => ({
    type: SUCCESS_UPDATE_DOCUMENT,
    payload: data,
})
export const updateDocumentFailure = (error) => ({
    type: FAILURE_UPDATE_DOCUMENT,
    payload: error,
})

export const requestUpdateEditHistoryDocument = () => ({
    type: REQUEST_UPDATE_EDIT_HISTORY_DOCUMENT,
})
export const updateEditHistoryDocumentSuccess = (data) => ({
    type: SUCCESS_UPDATE_EDIT_HISTORY_DOCUMENT,
    payload: data,
})
export const updateEditHistoryDocumentFailure = (error) => ({
    type: FAILURE_UPDATE_EDIT_HISTORY_DOCUMENT,
    payload: error,
})

export const requestFileDownload = () => ({
    type: REQUEST_FILE_DOWNLOAD,
})
export const fileDownloadSuccess = (data) => ({
    type: SUCCESS_FILE_DOWNLOAD,
    payload: data,
})
export const fileDownloadFailure = (error) => ({
    type: FAILURE_FILE_DOWNLOAD,
    payload: error,
})

export const requestGetDocumentEditHistory = () => ({
    type: REQUEST_GET_DOCUMENT_EDIT_HISTORY,
})
export const getDocumentEditHistorySuccess = (data) => ({
    type: SUCCESS_GET_DOCUMENT_EDIT_HISTORY,
    payload: data,
})
export const getDocumentEditHistoryFailure = (error) => ({
    type: FAILURE_GET_DOCUMENT_EDIT_HISTORY,
    payload: error,
})

export const requestGetSearchResult = () => ({
    type: REQUEST_GET_SEARCH_RESULT,
})
export const getSearchResultSuccess = (data) => ({
    type: SUCCESS_GET_SEARCH_RESULT,
    payload: data,
})
export const getSearchResultFailure = (error) => ({
    type: FAILURE_GET_SEARCH_RESULT,
    payload: error,
})

// export const updateSessionExpiry = (nextDay) => ({
//     type: UPDATE_SESSION_EXPIRY,
//     payload: nextDay,
// })
